import {
  Directive,
  EventEmitter,
  Output,
  ElementRef,
  HostListener,
} from '@angular/core';

@Directive({
    selector: '[gdxClickOutside]',
    standalone: false
})
export class ClickOutsideDirective {
  @Output() gdxClickOutside = new EventEmitter<void>();

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:click', ['$event.target'])
  public onClick(target: any): void {
    const clickedInside = this.elementRef.nativeElement.contains(target);
    if (!clickedInside) {
      this.gdxClickOutside.emit();
    }
  }
}
